import {Component, computed} from '@angular/core';
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {AccountPageLinkComponent} from "./account-page-link/account-page-link.component";
import {UserService} from "../../../services/user.service";
import {Button} from "primeng/button";
import {AuthService} from "../../../services/auth/auth.service";

@Component({
  standalone: true,
  imports: [
    PageTitleComponent,
    AccountPageLinkComponent,
    Button
  ],
  templateUrl: './account-page.component.html',
})
export class AccountPageComponent {
  protected readonly user = this.userService.userAfterSignupFlow;
  protected readonly email = computed(
    () => {
      const user = this.userService.user();
      return user && user.status !== 'unauthorized' ? user.email : undefined;
    }
  );

  protected readonly accountPageLinks = computed(() => {
    const user = this.user();

    const includeSubscription = user?.paymentInfo.type !== 'deferred';

    const links = [
      {title: 'Login details', path: ['login-details']},
      {title: 'Notification Preferences', path: ['notifications']},
      ...(includeSubscription ? [{title: 'Subscription', path: ['subscription']}] : []),
      {title: 'My Housing Connect account', path: ['housing-connect']},
      {title: 'Terms & Conditions', path: ['terms-and-conditions']},
      {title: 'Privacy Policy', path: ['privacy-policy']},
      {title: 'My data', path: ['my-data']},
      {title: 'About us', path: ['about']},
    ];

    return links;

  });

  constructor(
    private readonly userService: UserService,
    private readonly authService: AuthService,
  ) {
  }

  logout() {
    this.authService.logout();
  }
}
